import watchGetRoles from './getRoles';
import watchDeleteRole from './deleteRole';

const watchRoles = [watchGetRoles, watchDeleteRole];

export default watchRoles;
